import { useRef, useMemo, useEffect } from 'react';
import { useLocation, useSelector } from 'umi';
import { namespace as GUIDE_NAMESPACES, GUIDE_TYPE_INTELLIGENCE_COMPANY } from '@home/models/guide';
import { parseUserGuideStep } from '@intelligence/components/UserGuide/utils';

export default function useGamesShareCardAutoScrollIntoViewEffect(isLoading: boolean) {
  const location = useLocation();

  const { guideType } = useSelector((state: any) => state?.[GUIDE_NAMESPACES] || {});

  const timer = useRef<any>(null);

  const urlSearchParams = useMemo<URLSearchParams>(() => {
    return new URLSearchParams(location.search?.slice(1));
  }, [location.search]);

  const guideStep = useMemo<number>(() => {
    const from = urlSearchParams?.get('from') || '';
    return parseUserGuideStep(from);
  }, [urlSearchParams]);

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }
  };

  useEffect(() => {
    if (isLoading) return;
    if (guideType !== GUIDE_TYPE_INTELLIGENCE_COMPANY) return;
    if (guideStep !== 3) return;

    timer.current = setTimeout(() => {
      const node = document.querySelector('.dbi-companies-details');
      if (node) {
        node.scrollBy({
          top: 900,
          behavior: 'smooth',
        });
      }
      clearTimer();
    });

    return () => {
      clearTimer();
    };
  }, [isLoading, guideType, guideStep]);
};
